import gsap from "gsap/gsap-core";
import {breakpointUp} from "../utils/breakpoints";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Draggable} from "gsap/Draggable";
import {
  getSmoothScroll,
  smoothScrollPause,
  smoothScrollPlay,
} from "../scroll-smoother";
import {Swiper} from "swiper";
import {FreeMode, Navigation, Pagination} from "swiper/modules";

gsap.registerPlugin(Draggable)

$(document).ready(function () {
  const block = document.querySelector('.history-heroes')
  if (!block) return false

  function changePaginator() {
    const activeElement = $('.swiper-wrapper .swiper-slide.swiper-slide-active');
    var activeIndex = activeElement.index() + 1;
    $('.js--history-heroes-paginator .current').text(activeIndex);
    var activeSlide = activeElement[0];
    activeSlide.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});

  }

  function changeActiveHero(name, load) {
    smoothScrollPause();
    $('body').addClass('overflow-hidden');
    $('html').addClass('overflow-hidden');
    const smoothScroller = getSmoothScroll();
    const newUrl = new URL(window.location.href);
    $(`[data-hero-open]`).removeClass('active-single-hero');
    $(`[data-carousel-hero]`).removeClass('swiper-slide-active');
    newUrl.searchParams.set('hero', name);
    window.history.replaceState({}, '', newUrl);
    const modal = $('.js-history-heroes-modal')
    modal.addClass('modal-active');
    const heroToOpen = $(`[data-hero-open="${name}"]`);
    heroToOpen.addClass('active-single-hero');
    updateMeta(false, heroToOpen.data('meta-title'), heroToOpen.data('meta-description'), false);
    $(`[data-carousel-hero="${name}"]`).addClass('swiper-slide-active');
    gsap.fromTo('.active-single-hero', {opacity: 0, y: 50}, {opacity: 1, y: 0, duration: 0.5})
    $(".js-history-heroes-modal .inner-children").scrollTop(0);
    changePaginator();
    window.initBasicCarousel();
    setTimeout(() => {
      if ($(window).width() >= 1280) {
        smoothScrollPlay();
        document.documentElement.style.scrollBehavior = 'unset';
        const hero = $(`[data-hero="${name}"]`)[0];
        smoothScroller.scrollTop(hero.offsetLeft - (hero.clientWidth / 2));
        $('body').addClass('overflow-hidden');
        $('html').addClass('overflow-hidden');
        document.documentElement.style.scrollBehavior = 'smooth';
      }
    }, load ? $('.into-modal') ? 8000 : 1200 : 0);
  }

  const newUrl = new URL(window.location.href);
  if (newUrl.searchParams.get('hero')) {
    changeActiveHero(newUrl.searchParams.get('hero'), true);
  }

  $('.js--open-single-hero').on('click', function () {
    const value = $(this).data('hero');
    if (value) {
      changeActiveHero(value);
    }
    updateMeta(false, $(this).data('meta-title'), $(this).data('meta-description'), false);
  });
  $('.js--swiper-nav-prev').on('click', function () {
    const value = $('.active-single-hero').data('hero-open-prev')
    if (value) {
      changeActiveHero(value);
    }
  });

  $('.js--swiper-nav-next').on('click', function () {
    const value = $('.active-single-hero').data('hero-open-next')
    if (value) {
      changeActiveHero(value);
    }
  });

  $('[data-carousel-hero]').on('click', function () {
    const value = $(this).data('carousel-hero');
    if (value) {
      changeActiveHero(value);
    }
  });


  $('.js-history-heroes-modal .js--history-modal-close-btn').on('click', function () {
    updateMeta(true);
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('hero');
    window.history.replaceState({}, '', newUrl);
    const modal = $('.js-history-heroes-modal')
    modal.removeClass('modal-active');
    $(`[data-hero-open]`).removeClass('active-single-hero');
    $(`[data-carousel-hero]`).removeClass('swiper-slide-active');
    $('body').removeClass('overflow-hidden');
    $('html').removeClass('overflow-hidden');

    smoothScrollPlay();
  });


  ScrollTrigger.create({
    trigger: '#smooth-wrapper',
    pin: '.js-history-heroes-modal',
    top: 'top top',
    start: "top top",
    scrub: true,
    pinReparent: true,
    pinType: 'fixed',
    endTrigger: 'footer',
    pinSpacing: false,
    end: 'bottom+=30000vh bottom',
  });
  window.initHistoryHeroesSlider();

  $('.js--open-single-hero').each(function () {
    if ($(this).find('.js--custom-hero-cursor').length > 0) {
      const thisVideoButton = $(this).find('.js--custom-hero-cursor')

      $(this).on('mousemove', function (event) {
        if ($(window).width() >= 1280) {

          var offset = $(this).offset();
          var relativeX = event.pageX - offset.left;
          var relativeY = event.pageY - offset.top;
          var rectHeight = $(this).find('.js--custom-hero-cursor .svg-rect').outerHeight() / 2
          var rectHeightRotated = Math.sqrt(2) * rectHeight;

          if (relativeX - rectHeightRotated < 0 || relativeY - rectHeightRotated < 0 || relativeX + rectHeightRotated > $(this).width() || relativeY + rectHeightRotated > $(this).outerHeight()) {
            thisVideoButton.removeClass('shown');
          } else {
            thisVideoButton.addClass('shown');
          }
          gsap.set(thisVideoButton, {left: relativeX, top: relativeY});

        }
      });

      $(this).on('mouseleave', function () {
        thisVideoButton.removeClass('shown')
      });
    }
  });

});

let historyHeroesTl;
let historyHeroesScroll;
window.drag = undefined;

window.initHistoryHeroesSlider = () => {
  const block = document.querySelector('.history-heroes')
  if (!block) return false
  const smoothScroller = getSmoothScroll();

  const clearHistoryHeroes = () => {
    if (historyHeroesScroll) {
      historyHeroesScroll.kill();
      historyHeroesScroll = null;
    }
    if (historyHeroesTl) {
      historyHeroesTl.kill();
      historyHeroesTl = null;
    }
    if (window.drag) {
      window.drag.kill();
      window.drag = null;
    }
  };
  clearHistoryHeroes();
  if ($(window).width() >= 1280) {


    const cont = document.querySelector(".hero-list");
    const panels = gsap.utils.toArray(".hero-list .single-hero");
    historyHeroesTl = gsap.to(panels, {
      x: () => `-${cont.scrollWidth - (innerWidth * 0.895)}`,
      ease: "none",
    });

    historyHeroesScroll = ScrollTrigger.create({
      animation: historyHeroesTl,
      trigger: ".history-heroes",
      pin: true,
      start: "top top",
      scrub: 1,
      end: () => `+=${cont.scrollWidth - (innerWidth * 0.895)}`,
    });

    window.drag = Draggable.create(".drag-proxy", {
      type: "x",
      trigger: '.history-heroes',
      allowContextMenu: true,
      bounds: {minX: 0, maxX: -1 * historyHeroesScroll.end},
      onPress() {
        this.startScroll = historyHeroesScroll.scroll();
      },
      onDragStart() {
        // smoothScroller.paused(true)
        document.documentElement.style.scrollBehavior = 'unset';
      },
      onDrag() {
        smoothScroller.scrollTop(this.x * -1);
      },
      onDragEnd() {
        // smoothScroller.paused(false)
        document.documentElement.style.scrollBehavior = 'smooth';
      }
    })[0];

  }
}

